module.exports = __webpack_public_path__ + "img/topicSurveys.242655f8.webp";